import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';
import { digger } from '@cbre/digger';
import { L10nTranslationService } from 'angular-l10n';

@Component({
  template: `
    <div *ngIf="groupStatic; else rowBlock">
      <span class="record-value">
        {{ value }}
        <svg height="10" width="10">
          <circle cx="5" cy="5" r="4" stroke="black" stroke-width="1" fill="orange" />
        </svg>
      </span>
    </div>
    <ng-template #rowBlock>
      <miq-goes-to-record
        class="go-to"
        classes="go-to-record"
        [useIcon]="useIcon"
        [id]="id"
        [type]="type"
        [toolTipMessage]="toolTipMessage"
        [toolTipPosition]="toolTipPosition"
        [navigateOptionsFn]="navigateOptionsFn"
        svgIconName="new-window"
        targetAnchor="_blank"
      >
        <mat-icon *ngIf="showFlag" class="flagicon" [matTooltip]="flagTooltip">flag</mat-icon>
        <span class="record-value"
          >{{ value }}
          <svg *ngIf="static" height="10" width="10">
            <circle cx="5" cy="5" r="4" stroke="black" stroke-width="1" fill="orange" />
          </svg>
        </span>
      </miq-goes-to-record>
    </ng-template>
  `,
  styleUrls: ['go-to-record-renderer.component.scss'],
  standalone: false,
})
export class GoToRecordRendererComponent implements ICellRendererAngularComp {
  public value: string = undefined;
  public id: number = undefined;
  public type: string = undefined;
  public useIcon = false;
  public toolTipMessage: string;
  public static = false;
  public groupStatic = false;
  public toolTipPosition: string;
  public navigateOptionsFn: (options: any) => void;
  public showFlag = false;
  public flagTooltip: string;

  constructor(public translationService: L10nTranslationService) {}

  refresh(params: any): boolean {
    this.setValues(params);
    return true;
  }
  agInit(params: ICellRendererParams): void {
    this.setValues(params);
  }

  private setValues(params: ICellRendererParams) {
    this.useIcon = !!params['useIcon'];
    this.value = params.value;
    if (params.node.group) {
      if (params.node?.aggData?.staticQuarterDataF != null) {
        this.groupStatic = params.node.aggData.staticQuarterDataF > 0;
      }
    } else {
      this.type = params['goToRecordType'];
      this.id = digger(params.data, params['goToRecordIdPath']);
      const recordStatic = digger(params.data, params['goToRecordStatic']);
      this.static = recordStatic != null && recordStatic === 'Y';
      if (params['showFlag'] === true) {
        this.showFlag = params.data?.[params['showFlagPath']];
        this.flagTooltip = this.translationService.translate(params['flagTooltip']);
      }
    }
    this.toolTipMessage =
      !!params['toolTipMessage'] && this.translationService.has(params['toolTipMessage'])
        ? this.translationService.translate(params['toolTipMessage'])
        : params['toolTipMessage'];
    this.toolTipPosition = params['toolTipPosition'] ?? 'below';
    this.navigateOptionsFn = params['navigateOptionsFn'];
  }
}
